module.exports = __webpack_public_path__ + "static/media/taotao.3805aeca.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/LessonPath/static/img/taotao.png
// module id = 717
// module chunks = 1